import React, { useState } from "react";
import "./Questions.scss";

const Questions = ({
  questions,
  onQuestionDataChange,
  sectionOrderId,
  setQuestionsData,
  formStatus,
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newQuestion, setNewQuestion] = useState("");
  const [questionsList, setQuestionsList] = useState(questions || {});
  const [editIdx, setEditIdx] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [isEditingSubSection, setIsEditingSubSection] = useState(false);
  const [subSectionEditValue, setSubSectionEditValue] = useState("");

  // Add New Point
  const handleAddQuestion = () => {
    if (newQuestion.trim()) {
      const newOrderId =
        questionsList.questions && questionsList.questions.length > 0
          ? (
              parseInt(
                questionsList.questions[questionsList.questions.length - 1]
                  .orderId,
                10
              ) + 1
            ).toString()
          : "1";
      const newQuestionObj = {
        orderId: newOrderId,
        text: newQuestion,
        is_required: false,
      };
      setQuestionsList({
        ...questionsList,
        questions: [...(questionsList.questions || []), newQuestionObj],
      });
      setNewQuestion("");
      setIsAdding(false);
      onQuestionDataChange(
        {
          ...questionsList,
          questions: [...(questionsList.questions || []), newQuestionObj],
        },
        sectionOrderId
      );
    }
  };

  // Edit functionality
  const handleEdit = (idx, question) => {
    setEditIdx(idx);
    setEditValue(question);
  };

  const handleEditSave = (idx) => {
    setQuestionsList({
      ...questionsList,
      questions: questionsList.questions.map((q, i) =>
        i === idx ? { ...q, text: editValue } : q
      ),
    });
    setEditIdx(null);
    setEditValue("");
    onQuestionDataChange(
      {
        ...questionsList,
        questions: questionsList.questions.map((q, i) =>
          i === idx ? { ...q, text: editValue } : q
        ),
      },
      sectionOrderId
    );
  };

  const handleEditCancel = () => {
    setEditIdx(null);
    setEditValue("");
  };

  // Subsection editing functionality
  const handleSubSectionEdit = () => {
    setIsEditingSubSection(true);
    setSubSectionEditValue(questionsList?.subSectionName || "");
  };

  const handleSubSectionEditSave = () => {
    if (subSectionEditValue.trim()) {
      setQuestionsList({
        ...questionsList,
        subSectionName: subSectionEditValue,
      });
      setIsEditingSubSection(false);
      setSubSectionEditValue("");
      onQuestionDataChange(
        {
          ...questionsList,
          subSectionName: subSectionEditValue,
        },
        sectionOrderId
      );
    }
  };

  const handleSubSectionEditCancel = () => {
    setIsEditingSubSection(false);
    setSubSectionEditValue("");
  };

  const handleSubSectionDelete = () => {
    // Send null to indicate this sub-section should be deleted
    // Include the subSectionOrderId to identify which sub-section to delete
    onQuestionDataChange({ 
      subSectionOrderId: questionsList.subSectionOrderId, 
      deleteSubSection: true 
    }, sectionOrderId);
  };

  const handleDelete = (idx) => {
    setQuestionsList({
      ...questionsList,
      questions: questionsList.questions.filter((_, i) => i !== idx),
    });
    onQuestionDataChange(
      {
        ...questionsList,
        questions: questionsList.questions.filter((_, i) => i !== idx),
      },
      sectionOrderId
    );
  };

  const handleCancel = () => {
    setNewQuestion("");
    setIsAdding(false);
  };

  return (
    <div
      className="ques-sub-section"
      style={{ border: !questionsList && "none" }}
    >
      <div className="ques-sub-section-cont">
        {isEditingSubSection ? (
          <div className="ques-list-item-cont">
            <input
              type="text"
              value={subSectionEditValue}
              onChange={(e) => setSubSectionEditValue(e.target.value)}
              className="ques-add-new-input"
              autoFocus
            />
            <div className="ques-add-new-buttons">
              <button
                className="ques-add-btn"
                onClick={handleSubSectionEditSave}
                disabled={!subSectionEditValue.trim()}
              >
                Save
              </button>
              <button
                className="ques-cancel-btn"
                onClick={handleSubSectionEditCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <>
            <h3 className="ques-sub-section-title">
              {questionsList?.subSectionName}
            </h3>
            {formStatus !== "Publish" && (
              <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                <div style={{cursor: 'pointer'}} onClick={handleSubSectionEdit}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="ques-edit-icon"
                  >
                    <path
                      d="M3 17.4585V20.4985C3 20.7785 3.22 20.9985 3.5 20.9985H6.54C6.67 20.9985 6.8 20.9485 6.89 20.8485L17.81 9.93854L14.06 6.18854L3.15 17.0985C3.05 17.1985 3 17.3185 3 17.4585ZM20.71 7.03854C20.8027 6.94602 20.8762 6.83613 20.9264 6.71516C20.9766 6.59419 21.0024 6.46451 21.0024 6.33354C21.0024 6.20257 20.9766 6.07289 20.9264 5.95191C20.8762 5.83094 20.8027 5.72105 20.71 5.62854L18.37 3.28854C18.2775 3.19583 18.1676 3.12229 18.0466 3.07211C17.9256 3.02192 17.796 2.99609 17.665 2.99609C17.534 2.99609 17.4043 3.02192 17.2834 3.07211C17.1624 3.12229 17.0525 3.19583 16.96 3.28854L15.13 5.11854L18.88 8.86854L20.71 7.03854Z"
                      fill="#8D8D8D"
                    />
                  </svg>
                </div>
                <div style={{cursor: 'pointer'}} onClick={handleSubSectionDelete}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="ques-delete-icon"
                  >
                    <path
                      d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM18 4H15.5L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4Z"
                      fill="#FF0000"
                    />
                  </svg>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {questionsList?.questions && questionsList?.questions.length > 0 && (
        <ul className="ques-list">
          {questionsList.questions.map((q, idx) => (
            <li className="ques-list-item" key={q.orderId}>
              <div className="ques-list-item-cont">
                {editIdx === idx ? (
                  <>
                    <input
                      type="text"
                      value={editValue}
                      onChange={(e) => setEditValue(e.target.value)}
                      className="ques-add-new-input"
                      autoFocus
                    />
                    <div className="ques-add-new-buttons">
                      <button
                        className="ques-add-btn"
                        onClick={() => handleEditSave(idx)}
                        disabled={!editValue.trim()}
                      >
                        Save
                      </button>
                      <button
                        className="ques-cancel-btn"
                        onClick={handleEditCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <p className="ques-list-item-txt">{q.text}</p>
                    {formStatus !== "Publish" && (
                      <div className="ques-mark-required-cont">
                        <label>
                          <input
                            type="checkbox"
                            className="ques-mark-required-input"
                            name={`required-auditprompt-group-${q.orderId}`}
                            checked={q.is_required}
                            onChange={() => {
                              setQuestionsList({
                                ...questionsList,
                                questions: questionsList.questions.map(
                                  (item, i) =>
                                    i === idx
                                      ? {
                                          ...item,
                                          is_required: !item.is_required,
                                        }
                                      : item
                                ),
                              });
                              onQuestionDataChange(
                                {
                                  ...questionsList,
                                  questions: questionsList.questions.map(
                                    (item, i) =>
                                      i === idx
                                        ? {
                                            ...item,
                                            is_required: !item.is_required,
                                          }
                                        : item
                                  ),
                                },
                                sectionOrderId
                              );
                            }}
                          />
                          Mark as Required
                        </label>
                      </div>
                    )}
                  </>
                )}
              </div>
              {formStatus !== "Publish" && (
                <div className="ques-list-item-btns">
                  <div
                    className="ques-edit-btn"
                    onClick={() => handleDelete(idx)}
                  >
                    <p>Delete</p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM18 4H15.5L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4Z"
                        fill="#8D8D8D"
                      />
                    </svg>
                  </div>
                  <div
                    className="ques-edit-btn"
                    onClick={() => handleEdit(idx, q.text)}
                  >
                    <p>Edit</p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="ques-edit-icon"
                    >
                      <path
                        d="M3 17.4585V20.4985C3 20.7785 3.22 20.9985 3.5 20.9985H6.54C6.67 20.9985 6.8 20.9485 6.89 20.8485L17.81 9.93854L14.06 6.18854L3.15 17.0985C3.05 17.1985 3 17.3185 3 17.4585ZM20.71 7.03854C20.8027 6.94602 20.8762 6.83613 20.9264 6.71516C20.9766 6.59419 21.0024 6.46451 21.0024 6.33354C21.0024 6.20257 20.9766 6.07289 20.9264 5.95191C20.8762 5.83094 20.8027 5.72105 20.71 5.62854L18.37 3.28854C18.2775 3.19583 18.1676 3.12229 18.0466 3.07211C17.9256 3.02192 17.796 2.99609 17.665 2.99609C17.534 2.99609 17.4043 3.02192 17.2834 3.07211C17.1624 3.12229 17.0525 3.19583 16.96 3.28854L15.13 5.11854L18.88 8.86854L20.71 7.03854Z"
                        fill="#8D8D8D"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
      {/* Only show Add New Point if subsection exists */}
      {!isAdding && formStatus !== "Publish" && questionsList ? (
        <div
          className="ques-list-item-txt ques-add-new"
          onClick={() => setIsAdding(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M15 8.75C14.3125 8.75 13.75 9.3125 13.75 10V13.75H10C9.3125 13.75 8.75 14.3125 8.75 15C8.75 15.6875 9.3125 16.25 10 16.25H13.75V20C13.75 20.6875 14.3125 21.25 15 21.25C15.6875 21.25 16.25 20.6875 16.25 20V16.25H20C20.6875 16.25 21.25 15.6875 21.25 15C21.25 14.3125 20.6875 13.75 20 13.75H16.25V10C16.25 9.3125 15.6875 8.75 15 8.75ZM15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5ZM15 25C9.4875 25 5 20.5125 5 15C5 9.4875 9.4875 5 15 5C20.5125 5 25 9.4875 25 15C25 20.5125 20.5125 25 15 25Z"
              fill="#8D8D8D"
            />
          </svg>
          <p className="ques-add-new-txt">Add New Point</p>
        </div>
      ) : null}
      {isAdding ? (
        <div className="ques-add-new-input-container">
          <input
            type="text"
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
            placeholder="Enter new question"
            className="ques-add-new-input"
            autoFocus
          />
          <div className="ques-add-new-buttons">
            <button
              className="ques-add-btn"
              onClick={handleAddQuestion}
              disabled={!newQuestion.trim()}
            >
              Add
            </button>
            <button className="ques-cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Questions;
